// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "c8e020eb-dirty",
    "hash": "c8e020eb",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c8e020eb-dirty",
    "semverString": null,
    "version": "5.0.1"
};
/* tslint:enable */
